var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21.4706H0.500001V8.47058H5.5V21.4706ZM14.5 12.4706C13.9696 12.4706 13.4609 12.6813 13.0858 13.0564C12.7107 13.4314 12.5 13.9401 12.5 14.4706V21.4706H7.5V8.47058H12.5V9.95558C13.6163 9.00947 15.0268 8.48096 16.49 8.46058C19.452 8.46058 21.5 10.6606 21.5 14.8156V21.4706H16.5V14.4706C16.5 13.9401 16.2893 13.4314 15.9142 13.0564C15.5391 12.6813 15.0304 12.4706 14.5 12.4706ZM5.5 3.97058C5.5 4.46503 5.35338 4.94838 5.07867 5.35951C4.80397 5.77063 4.41352 6.09106 3.95671 6.28028C3.49989 6.4695 2.99723 6.51901 2.51228 6.42254C2.02732 6.32608 1.58187 6.08798 1.23223 5.73835C0.882603 5.38872 0.644501 4.94326 0.548038 4.45831C0.451575 3.97335 0.501083 3.47069 0.690302 3.01387C0.879521 2.55706 1.19995 2.16661 1.61108 1.89191C2.0222 1.6172 2.50555 1.47058 3 1.47058C3.66304 1.47058 4.29893 1.73397 4.76777 2.20281C5.23661 2.67166 5.5 3.30754 5.5 3.97058Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinVector);
export default __webpack_public_path__ + "static/media/linkedin_vector.dd2016c33ceac01ff3f7053ac69ce123.svg";
export { ForwardRef as ReactComponent };